import type { ComponentType } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useMemo } from "react";

import { admin_cse } from "@/config/roles";
import { Dropdown as DropdownJs } from "@/component-library";
import { hasAccessToPaymentTab } from "@/utils/authUtils";
import { isAuthorized } from "@/utils/authToken";

import { PAYMENT_TAB } from "../../constants";

import { ProfileTabList } from "./ProfileTabList";

type DropdownOption = { label: string; value: string };
const Dropdown = DropdownJs as ComponentType<{
  onChange?: (e: { target: { value: string } }) => void;
  options: DropdownOption[];
  value?: DropdownOption;
}>;

const BASE_TABS = ["Care Plan", "Reports", "Notes", "Medical", "Timeline"];

export function ProfileTabs() {
  const location = useLocation();
  const history = useHistory();

  const selectedTab = new URLSearchParams(location.search).get("selectedTab") ?? "Care Plan";

  const tabs = useMemo(() => {
    const result = [...BASE_TABS];

    if (isAuthorized(admin_cse)) result.push("Admin");
    if (hasAccessToPaymentTab()) result.push(PAYMENT_TAB);

    return result;
  }, []);

  const handleTabChange = (tab: string) => {
    const searchParams = new URLSearchParams(history.location.search);

    searchParams.set("selectedTab", tab);
    history.push(`${history.location.pathname}?${searchParams.toString()}`);
  };

  const options = tabs.map((tab) => ({ label: tab, value: tab }));

  return (
    <>
      <ProfileTabList
        className="tw:mt-1 tw:px-5 tw:max-lg:hidden"
        onTabChange={handleTabChange}
        selectedTab={selectedTab}
        tabs={tabs}
      />

      <div className="tw:mt-4 tw:flex tw:items-center tw:gap-2 tw:lg:hidden">
        <p className="body-sm tw:whitespace-nowrap">
          <strong>Navigate to:</strong>
        </p>

        <Dropdown
          onChange={(e: { target: { value: string } }) => handleTabChange(e.target.value)}
          options={options}
          value={{ label: selectedTab, value: selectedTab }}
        />
      </div>
    </>
  );
}
